.chosen-option {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
}

.chosen-option-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.option {
  opacity: 2;
  min-width: 18rem;
  border-radius: 0.6rem;
  padding: 0.4rem;
  z-index: calc(var(--layer-modal) + 1);
  box-shadow: rgba(0, 0, 0, 0.2) 0 4px 24px;
  background: var(--color-grayscale-tuna);
  max-width: 46.8rem;

  &[data-size='free-size'] {
    min-width: unset;
  }
}

.list-item {
  position: relative;
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  padding: 1.2rem;
  gap: 0.2rem;

  &[data-highlighted] {
    cursor: pointer;
    background-color: rgba(124, 124, 163, 0.125);
  }
}
